export enum Market {
  BE = 'BE',
  NL = 'NL'
}
